import React, { useEffect, memo } from 'react'
import { useLocation } from "react-router-dom";
import mixpanel from 'mixpanel-browser';
import { useSelector } from 'react-redux';
import { mixPanelTrack } from 'utils/track';

const MixPanelTrack = memo(function MixPanelTrack() {

    const location = useLocation()
    const auth = useSelector(state => state.auth)

    useEffect(() => {
        try {
            const user_id = auth.email

            if (!user_id) return

            mixpanel.init('fd583321f4b6f97f01342a2d0bed1f53', { debug: true, track_pageview: true, persistence: 'localStorage' });

            mixpanel.identify(user_id)

            console.log("start mixpanel analytic")
        } catch {
            console.error("init maxpanel error")
        }

    }, [auth.email])

    useEffect(() => {
        try {
            mixPanelTrack('page_view', {
                path: location.pathname,
                grupo: auth.grupo_ativo
            })
        }
        catch {
            console.error('page_view error')
        }
    }, [location])

    return <></>
})

export default MixPanelTrack